import React from "react";
import { Box, Skeleton } from "@mui/material";
import { APP_BORDER } from "../createShared";
import { FORM_CONTROL } from "./formControlStyles";

const placeholderSx = {
  bgcolor: "rgba(255,255,255,0.09)",
  "&::after": {
    background:
      "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    "&::after": { animation: "none" },
  },
} as const;

/** Match the library's cards and compact rail while the first page loads. */
export default function CharacterLibrarySkeleton({
  expanded,
}: {
  expanded: boolean;
}) {
  return (
    <Box
      role="status"
      aria-label="Loading characters"
      aria-busy="true"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: expanded ? "stretch" : "center",
        width: "100%",
        boxSizing: "border-box",
        gap: expanded ? 1 : 1.5,
        pt: expanded ? 0 : "3px",
        pr: expanded ? 0.75 : 0,
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        maskImage: "linear-gradient(to bottom, #000 calc(100% - 32px), transparent)",
      }}
    >
      {Array.from({ length: 12 }, (_, index) => (
        <Box
          key={index}
          aria-hidden="true"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            flexShrink: 0,
            height: expanded ? 54 : "var(--character-rail-item-size)",
            boxSizing: "border-box",
            px: expanded ? 1.25 : 0,
            border: expanded ? `1px solid ${APP_BORDER}` : 0,
            borderRadius: "14px",
            bgcolor: expanded ? FORM_CONTROL.surface : "transparent",
          }}
        >
          <Box
            sx={{
              width: expanded ? 38 : "var(--character-rail-item-size)",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            <Skeleton
              animation="wave"
              variant="circular"
              width={expanded ? 34 : "var(--character-rail-item-size)"}
              height={expanded ? 34 : "var(--character-rail-item-size)"}
              sx={placeholderSx}
            />
          </Box>
          {expanded && (
            <Skeleton
              animation="wave"
              variant="rounded"
              width={`${[48, 62, 55, 38][index % 4]}%`}
              height={14}
              sx={{ ...placeholderSx, borderRadius: 1 }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
}
